import React, { useState } from 'react';
import css from './SectionCityGrid.module.css';

const CITIES = [
  { name: 'Atlanta', slug: 'atlanta', specialties: ['HIIT', 'Calisthenics'] },
  { name: 'Chicago', slug: 'chicago', specialties: ['Strength Training', 'Yoga'] },
  { name: 'Dallas', slug: 'dallas', specialties: ['Personal Training', 'CrossFit'] },
  { name: 'Denver', slug: 'denver', specialties: ['Outdoor Fitness', 'Climbing'] },
  { name: 'Houston', slug: 'houston', specialties: ['Boxing', 'Personal Training'] },
  { name: 'Los Angeles', slug: 'los-angeles', specialties: ['Pilates', 'Yoga'] },
  { name: 'Miami', slug: 'miami', specialties: ['Bootcamp', 'Swimming'] },
  { name: 'New York', slug: 'new-york', specialties: ['Personal Training', 'HIIT'] },
  { name: 'Philadelphia', slug: 'philadelphia', specialties: ['Strength Training', 'Running'] },
  { name: 'Phoenix', slug: 'phoenix', specialties: ['Personal Training', 'Yoga'] },
  { name: 'San Diego', slug: 'san-diego', specialties: ['Surfing Fitness', 'HIIT'] },
  { name: 'St. Louis', slug: 'st-louis', specialties: ['Personal Training', 'Kettlebell'] },
  { name: 'Seattle', slug: 'seattle', specialties: ['Hiking Fitness', 'Cycling'] },
  { name: 'Washington DC', slug: 'washington-dc', specialties: ['Bootcamp', 'Strength'] },
];

const VISIBLE_COUNT = 12;

const SectionCityGrid = () => {
  const [showAll, setShowAll] = useState(false);
  const displayed = showAll ? CITIES : CITIES.slice(0, VISIBLE_COUNT);

  return (
    <section className={css.root}>
      <div className={css.container}>
        <h2 className={css.title}>Browse by City</h2>
        <p className={css.subtitle}>Find certified trainers near you</p>

        <div className={css.grid}>
          {displayed.map(city => (
            <a key={city.slug} href={`/p/${city.slug}`} className={css.card}>
              <div className={css.cityName}>{city.name}</div>
              <div className={css.specialties}>
                {city.specialties.map(s => (
                  <a
                    key={s}
                    href={`/p/${city.slug}?specialty=${encodeURIComponent(s)}`}
                    className={css.specialtyTag}
                    onClick={e => e.stopPropagation()}
                  >
                    {s}
                  </a>
                ))}
              </div>
            </a>
          ))}
        </div>

        {!showAll && CITIES.length > VISIBLE_COUNT && (
          <button className={css.more} onClick={() => setShowAll(true)}>
            + {CITIES.length - VISIBLE_COUNT} more cities
          </button>
        )}
      </div>
    </section>
  );
};

export default SectionCityGrid;
